import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const CERTIFICATOR_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Certificator.Name')
    .required()
    .maxLength(50)
    .build(),
];

export const CERTIFICATOR_CONFIG = {
  entityName: 'Certificator',
  localizationKey: 'Planning::Entity.Certificator',
  fields: CERTIFICATOR_FIELDS,
  permission: 'Planning.Certificators',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Certification + MENU_NAME_SUFFIX,
};
